<template>
    <div v-if="typeItem">
        <div>
            <div @click.prevent="toChangeMode" class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                <div class="flex-shrink-0">
                    <component :is="typeItem.icon" class="text-gray-500 mr-4 flex-shrink-0 h-6 w-6" aria-hidden="true" />
                </div>
                <div class="flex-1 min-w-0">
                    <a href="#" class="focus:outline-none">
                        <span class="absolute inset-0" aria-hidden="true"></span>
                        <p class="text-sm font-medium text-gray-900">{{ typeItem.title }}</p>
                        <p class="text-sm text-gray-500">{{ typeItem.description }}</p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Link from "./type/Link.vue";
import CodeTypesList from "../CodeTypesList.vue";
import codeTypes from "../../../../../store/code_types"
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import {mapState} from "pinia";

export default {
    props: {
        destinationId: {
            required: true
        }
    },

    components: {
        Link,
        CodeTypesList
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        currentType: {
            get() {
                return this.code.destinations[this.destinationId].type
            },
        },
        typeItem() {
            return codeTypes.find(item => item.type === this.currentType)
        }
    },

    data() {
        return {
            type: null
        }
    },

    methods: {
        toChangeMode() {
            this.emitter.emit("toggle-qr-code-type-modal", this.destinationId)
        },
    }
}
</script>
